import React from "react";
import Skills from "../components/Skills";

function SkillsPage() {
  return <Skills />;
}

export default SkillsPage;